module.exports = __webpack_public_path__ + "static/hero-mockup-mobile-dark-19ffb2f0864b1a38385acb004626ee4c.png";